import { Timestamp } from "firebase/firestore";

/**
 * Formulário → Firestore
 * Converte dados do formulário React para a estrutura do Firestore.
 */
export const mediaToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const payload = {
        idTenant,
        name: data.name?.trim() || "",
        type: data.type || "single",
        imageUrl: data.imageUrl || null,
        carouselImages: data.carouselImages || [],
        slideDuration: Number(data.slideDuration) || 8,
        startDate: data.startDate || null,
        endDate: data.endDate || null,
        status: data.status || "active",

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

/**
 * Firestore → React
 * Converte a estrutura do Firestore para dados do formulário React.
 */
export const mediaFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
